import { Component, OnInit } from '@angular/core';

import { environment } from '../environments/environment';

import { IconService } from './core/services/icon.service';

@Component({
	selector: 'app-root',
	styleUrls: ['./app.component.scss'],
	templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
	favIcon: HTMLLinkElement;
	showStripe: boolean;
	stripeLabel: string = 'STAGING';
	title: HTMLTitleElement;

	constructor(private readonly iconsService: IconService) {
		this.title = document.querySelector('#apptitle')!;
		this.favIcon = document.querySelector('#appicon')!;
		this.showStripe =
			!environment.isProduction && !environment.isMaintenanceMode;
	}

	ngOnInit() {
		this.iconsService.setDefaultFont();
		this.iconsService.registerIcons();

		if (environment.isMaintenanceMode) {
			if (this.title) {
				this.title.innerText = 'Sanus - Manutenção';
			}
		} else if (!environment.isProduction) {
			if (this.favIcon) {
				this.favIcon.href = './assets/icons/favicon.staging.ico';
			}

			if (!environment.isStaging) {
				if (this.title) {
					this.title.innerText = 'Sanus - LOCAL';
				}
				this.stripeLabel = 'LOCAL';
			} else {
				this.title.innerText = 'Sanus - STAGING';
			}
		}
	}
}
